import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './AlertCounterStyles';

export default class AlertCounter extends Component {
  render() {
    const total = Object.keys(this.props).reduce((sum, item) => {
      return sum += (this.props[item].viewings.length === 0) ? 1 : 0
    }, 0)

    return (
        <div className={css(styles.counterWrapper)}>
          <span className={css(styles.lozenge)}>{total}</span>{` ${total === 1 ? 'alert needs' : 'alerts need'} your attention`}
        </div>
    );
  }
}
